import React, { useState, useEffect } from 'react';
import AdSense from "react-adsense";
import axios from 'axios';
import { Helmet } from "react-helmet";
import { FaMicrophone, FaStop } from 'react-icons/fa';
import { alert_error, alert_success } from "../AppContext.js";
import { useParams, useNavigate } from 'react-router-dom';
import { RingLoader } from "react-spinners";
import { TiTick } from 'react-icons/ti';
import { MdVolumeUp } from 'react-icons/md';
import { Cookies } from '../index.js';
import AudioPlayer from '../app_structure/AudioPlayer';
import Select from 'react-select';
const Texttovoice = () => {
  const navigate = useNavigate();
  const [src, setsrc] = useState('');
  const [thanhcong, setthanhcong] = useState(false);
  const [caption, setcaption] = useState(false);
  const [nutxuly, setnutxuly] = useState(0);
  const [nutorder, setnutorder] = useState(" Chuyển đổi 📝🌐");
  const [them20giay, setthem20giay] = useState('NO');
  const [dalaythongtin, setdalaythongtin] = useState(false);
  const [thongtincum, setthongtincum] = useState(false);
  const [ToChucIds, setToChucIds] = useState(false);
  const [huyen, sethuyen] = useState(false);
  const [loadstart, setloadstart] = useState(true);
  const [apikey, setapikey] = useState('');
  const [dungghi, setdungghi] = useState(false);
  const [text, setText] = useState('');
  const [isOpen, setIsOpen] = useState(true);
  const [isOpen2, setIsOpen2] = useState(false);
  const [typeuser, settypeuser] = useState('individual');
  const [service_name, setservice_name] = useState('');
  const [options, setOptions] = useState([
    { label: 'Giọng Nữ miền Bắc 1', value: 'viettel-north-women' },
    { label: 'Giọng Nữ miền Bắc 2', value: 'vi-VN-Wavenet-A' },
    { label: 'Giọng Nam miền Bắc', value: 'viettel-north-male' },
    { label: 'Giọng Nữ miền Trung', value: 'viettel-women' },
    { label: 'Giọng Nam miền Trung', value: 'viettel-male' },
  ]);
  const [options2, setOptions2] = useState([
    // { label: 'Phát luôn ra loa', value: 'NOW' },
    { label: 'Gốc cho Cụm internet', value: 'NO' },
    { label: 'Thêm 20 giây Cụm FM', value: 'YES' },
  ]);
  const [social, setSocial] = useState(null);
  const { slug_2 } = useParams();
  console.log(slug_2);
  const handleTextChange = (e) => {
    setText(e.target.value);
  };
  const countCharacters = () => {
    // Đếm số ký tự trong biến text
    let characterCount = text.length * 1 / 7;
    characterCount = Math.round(characterCount);
    return characterCount;
  };
  function testFunction(response) {
    console.log(response.data);
    const info = response.data;
    const status = info.status;
    const message = info.message;
    if (status == 0) {
      setnutxuly(0);
      alert_error(message);
      setnutorder(" Chuyển đổi 📝🌐");
      setthanhcong(false);
    }
    else if (response.data.voice.includes('lỗi')) {
      setnutxuly(0);
      alert_error("tiêu đề đã tồn tại");
      setnutorder("Đặt lại");
    } else if (status == 1) {

      if (thanhcong && typeuser == 'individual') {
        setnutxuly(0);
        alert_success("Thành công");
        setnutorder(" Chuyển đổi 📝🌐");
        setthanhcong(false);
      } else if (typeuser == 'personal' || typeuser == 'guest') {
        setnutxuly(0);
        alert_success("Thành công");
        setnutorder("Đặt tiếp luôn nào");
        setsrc(response.data.voice);
        setthanhcong(true);
      }
      else {
        setnutxuly(0);
        alert_success("Thành công");
        setnutorder("Đẩy lên file");
        setthanhcong(true);
        setsrc(response.data.voice);
      }

    }
  };
  const api_texttovoice = (url, data) => {
    axios.post(url, data)
      .then(response => {
        testFunction(response);
      })
      .catch(error => {
        setnutxuly(0);
        setnutorder("Đặt lại");
        alert_error(error)
      })
  }

  const handleTextToSpeech = () => {
    setnutxuly(1);
    // Xử lý logic chuyển văn bản thành giọng nói ở đây
    // Sử dụng giá trị trong biến `text`
    const convertedText = text.replace(/\n/g, '.');
    if (!convertedText || (!caption && typeuser == 'individual')) {
      setnutxuly(0);
      alert_error('Chưa nhập gì');
    }
    else {
      setnutorder("Đợi xíu nhé");
      resetok();
      // Gọi API Cloud Text-to-Speech với convertedText
      console.log('Converted Text:', convertedText);
      const url = 'https://tecom.pro/truyenthanh/texttovice.php';
      const apikey = Cookies.get('apikey');
      if (typeuser == 'personal') {
        const data = {
          caption: caption,
          key: apikey,
          text: convertedText,
          thanhcong: false,
          social: social,
          typeuser: typeuser,
          service_name: service_name,
          cumfm: them20giay
        };
        api_texttovoice(url, data);
      }
      else {
        const data = {
          caption: caption,
          key: apikey,
          text: convertedText,
          thanhcong: thanhcong,
          social: social,
          typeuser: typeuser,
          service_name: service_name,
          cumfm: them20giay
        };
        api_texttovoice(url, data);
      }
    }

  };

  useEffect(() => {
    const currentDomain = window.location.hostname;
    console.log(currentDomain);
    // if (currentDomain == 'localhost' || currentDomain == 'hust.media') {
    const checkhuyen = Cookies.get('huyen');
    const Type_user = Cookies.get('type_user');
    const myCookieValue = Cookies.get('apikey');
    if (myCookieValue) {
      setapikey(myCookieValue);
      if ((currentDomain == 'hust.media' || checkhuyen == 'ok' || Type_user == 'personal')) {
        if (checkhuyen == 'ok') {
          sethuyen(true);
          console.log(123);
        } else {
          setOptions([
            { label: 'Giọng Nữ miền Bắc 1', value: 'viettel-north-women' },
            { label: 'Giọng Nữ miền Bắc 2', value: 'vi-VN-Wavenet-A' },
            // { label: 'Giọng Nam miền Bắc', value: 'vi-VN-Wavenet-B' },
            { label: 'Giọng Nam miền Bắc', value: 'viettel-north-male' },
            { label: 'Giọng Nữ miền Trung', value: 'viettel-women' },
            { label: 'Giọng Nam miền Trung', value: 'viettel-male' },
            { label: 'Giọng Nữ miền Nam', value: 'viettel-south-women' },
            { label: 'Giọng Nam miền Nam', value: 'viettel-south-male' },
          ]);
        }
        settypeuser('personal');
        console.log(123);
      } else {
        laythongtin();
      }
    }
    else {
      settypeuser('guest');
      setSocial('viettel-north-women');
      setdalaythongtin(true);
      setloadstart(false);
    }
  }, []);
  function laythongtin() {

    axios.get('https://hust.media/truyenthanh/usercum.php', {
      params: {
        username: slug_2
      }
    })
      .then(response => {
        console.log(response.data); // Dữ liệu từ API
        setdalaythongtin(true);
        setthongtincum(response.data.Data);
        setToChucIds(parseInt(response.data.ToChucIds));
        console.log(ToChucIds); // 7134
        setloadstart(false);
        // Xử lý dữ liệu ở đây
      })
      .catch(error => {
        alert_error(error);
      });
  };


  const handleReset = () => {
    setnutorder(" Chuyển đổi 📝🌐");
    resetok();
  };
  const resetok = () => {
    setthanhcong(false);
    setsrc('');
  }

  const handleFocus = () => {
    setIsOpen(true);
    console.log(123);
  };
  const handleFocus2 = () => {
    setIsOpen2(true);
    console.log(123);
  };
  const handleBlur = () => {
    setIsOpen(false);
  };
  const handleBlur2 = () => {
    setIsOpen2(false);
  };
  const handleMenuOpen = () => {
    setIsOpen(true);
  };
  const handleMenuOpen2 = () => {
    setIsOpen2(true);
  };
  const handleChange = (selectedOption) => {
    setIsOpen(false);
    setSocial(selectedOption.value);
    // Tìm label tương ứng với giá trị được chọn
    setIsOpen2(true);
    const sdbfhsdfjsdf = options.find(option => option.value === selectedOption.value);
    console.log(sdbfhsdfjsdf.label);
    setservice_name(sdbfhsdfjsdf.label);
  };
  const handleChange2 = (selectedOption2) => {
    setthem20giay(selectedOption2.value);
    setIsOpen2(false);
  };
  function switch_router(link) {
    navigate(link);
  };
  const [tasks, settasks] = useState([
    { id: 1, name: 'Giọng miền bắc', url: 'https://tecom.pro/truyenthanh/file/texttovoice/i5qyetne717q63xut.mp3' },
    { id: 2, name: 'Giọng miền trung', url: 'https://tecom.pro/truyenthanh/file/texttovoice/9e326d38vwd8gi250.mp3' },
    { id: 3, name: 'Giọng miền nam', url: 'https://tecom.pro/truyenthanh/file/texttovoice/p19inb24otqevrq90.mp3' },
    // Thêm nhiệm vụ khác tại đây
  ]);
  return (
    <>
      <Helmet>
        <title>Chuyển văn bản thành giọng nói online</title>
        <meta name="description" content="Chuyển văn bản thành giọng nói cảm xúc như con người. Sáng tạo nội dung không giới hạn cùng Tecom bằng giọng đọc nhân tạo.Với Công nghệ Text To Speech." />
        <meta property="og:description" content="Chuyển văn bản thành giọng nói cảm xúc như con người. Sáng tạo nội dung không giới hạn cùng Tecom bằng giọng đọc nhân tạo.Với Công nghệ Text To Speech." />
      </Helmet>
      {

        typeuser == 'individual' && loadstart ? (<div className="flex justify-center items-center">
          <RingLoader size={80} color="#0000ff" />{" "}
        </div>
        ) :
          dungghi ? (<div className="flex justify-center items-center">
            <RingLoader size={80} color="#0000ff" loading={dalaythongtin} />{" "}
          </div>
          ) : !dalaythongtin && !thongtincum && typeuser != 'personal' ? (<div className="flex justify-center items-center">
            <RingLoader size={80} color="#0000ff" loading={dalaythongtin} />{" "}
          </div>
          ) : (
            <div className="max-w-2xl px-1 py-3   mx-auto rounded-lg shadow-xl ">

              <div className="mx-auto container-fluid mt-0  flex  flex-col  items-center justify-center ">
                {!apikey ?
                  (<>
                    <div className="bg-white p-2 rounded-md shadow-md ">
                      <div className="bg-gray-100 rounded-md shadow-md border-1 border-purple-300">
                        <div className="py-2 px-2 text-center text-sm text-purple-700"> Tecom là công cụ chuyển văn bản thành giọng nói miễn phí cung cấp dịch vụ tổng hợp giọng nói và hỗ trợ nhiều vùng miền, bao gồm miền bắc, miền trung, miền nam, v.v. Bạn có thể sử dụng nó để đọc văn bản và sách điện tử hoặc tải xuống các tệp âm thanh để sử dụng cho mục đích thương mại (hoàn toàn miễn phí).
                          {/* Là một công cụ TTS miễn phí tuyệt vời, Tecom có thể dễ dàng chuyển đổi văn bản thành giọng nói trực tuyến. */}
                        </div>
                      </div>
                    </div>

                    <table className="mb-2 mt-2 w-full border shadow-lg rounded-lg">
                      <thead className="bg-blue-500 text-white">
                        <th className="border px-3 py-2 w-1/3">Loại voice</th>
                        <th className="border px-3 py-2 w-2/3">Nghe thử</th>

                      </thead>
                      <tbody>
                        {tasks.map((task) => (
                          <tr key={task.id} className="hover:bg-gray-100">
                            <td className="border px-6 py-3 lg:w-1/3 px-3 py-2 ">
                              <div className="flex items-center justify-between flex-1"
                              // onClick={() => clickmission(task.id)} 
                              >
                                {task.name}
                              </div>
                            </td>
                            <td className="border lg:w-2/3 px-2 py-1">
                              <audio controls className="w-full">
                                <source src={task.url} type="audio/mpeg" />
                                Your browser does not support the audio element.
                              </audio>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>) : (<>
                    {typeuser == 'personal' ?
                      (
                        <div className="mb-2 row align-items-center">
                          <div className="col mb-0">
                            <div className="col text-left">
                              <label htmlFor="countries2" className="text-center text-xs  mb-0  font-medium">
                                Chọn giọng nói
                              </label>
                            </div>
                          </div>
                          <button onClick={() => switch_router("/reactapp/texttovoicehistory?app=showadview")} className="col text-right">
                            <div htmlFor="countries2" className="rounded-xl border-1 text-center text-xs  mb-0  font-medium">
                              Nhật ký chuyển
                            </div>
                          </button>
                        </div>
                      ) :
                      (<label htmlFor="countries2" className="mt-1 text-center text-xs  mb-0  font-medium">
                        Chọn giọng nói
                      </label>)}
                    <Select
                      className="w-full max-w-md"
                      classNamePrefix="Chọn 1 lựa chọn"
                      onFocus={handleFocus}
                      options={options}
                      menuIsOpen={isOpen}
                      onBlur={handleBlur}
                      onMenuOpen={handleMenuOpen}
                      onChange={handleChange} // Use selectedOption.value to get the selected value
                      isDisabled={false}
                      isLoading={false}
                      isClearable={true}
                      isRtl={false}
                      isSearchable={false}
                    />
                    {typeuser != 'personal' &&
                      (
                        <>
                          <label htmlFor="countries2" className="text-center text-xs  mb-0  font-medium">
                            Chọn kiểu chuyển
                          </label>
                          <Select
                            className="w-full max-w-md"
                            classNamePrefix="Chọn 1 lựa chọn"
                            onFocus={handleFocus2}
                            options={options2}
                            menuIsOpen={isOpen2}
                            onBlur={handleBlur2}
                            onMenuOpen={handleMenuOpen2}
                            onChange={handleChange2} // Use selectedOption.value to get the selected value
                            isDisabled={false}
                            isLoading={false}
                            isClearable={true}
                            isRtl={false}
                            isSearchable={false}
                          />
                          <p className="text-xs mb-0  text-gray-900 dark:text-gray-400">Nhập Tiêu đề </p>
                          <input
                            type="text"
                            onChange={e => setcaption(e.target.value)}
                            className="border border-gray-300 rounded px-1 py-2 w-full max-w-md mb-3"
                            placeholder="Dùng để phân biệt cái khác"
                          />
                        </>
                      )
                    }
                  </>)}
                <p className="text-xs mb-0  text-gray-900 dark:text-gray-900">Nhập Văn bản </p>
                <textarea
                  value={text}
                  onChange={handleTextChange}
                  className="border border-gray-300 rounded h-40 px-3 py-2 w-full max-w-md resize-none focus:outline-none mx-2 mb-2"
                  placeholder="Tiếng việt"
                />
                {
                  typeuser == 'personal' && !huyen &&
                  (
                    <><p>🛒 {countCharacters()} Coins</p>   </>
                  )
                }
                {thanhcong && (
                  <>
                    <AudioPlayer src={src} onReset={handleReset} />
                  </>
                )}
                <button disabled={nutxuly == 1}
                  onClick={handleTextToSpeech}
                  className="my-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-0 w-full dark:bg-slate-800 dark:text-white"
                >
                  <div className="flex items-center justify-between flex-1">
                    {nutxuly == 1 && (
                      <div className="spinner-border" role="status"></div>
                    )}

                    <span className="text-xl font-medium text-white">
                      {nutorder}{" "}
                    </span>

                    <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                  </div>
                </button>

              </div>
              {window.location.hostname == 'hust.media' && !huyen && (
                <div className="mt-1 max-h-32">
                  <div className="cards">
                    <AdSense.Google
                      client="ca-pub-4574266110812955"
                      slot="8795043992"
                      style={{ display: "block", height: 100 }}
                      format=""
                    />
                  </div>   </div>)}

            </div>
          )}
    </>
  );
};

export default Texttovoice;
